import React from 'react';
import { Select, Spin } from 'antd';
import 'baseComponents/SearchableDropdownSelectComponent/searchableDropdownSelectComponent.scss';
import { ChevronDownIcon } from 'assets/icons/chevronDownIcon';

interface Props {
  options: any;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  placeholder: string;
  value: any;
  disabled?: boolean;
  loading?: boolean;
  multiselect?: boolean;
}

// Filter `option.label` match the user type `input`
const filterOption = (
  input: string,
  option?: { label: string; value: string }
) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export const SearchableDropdownSelectComponent: React.FC<Props> = (props) => {
  if (props.multiselect) {
    return (
      <Select
        mode='multiple'
        showSearch
        placeholder={props.placeholder}
        className='searchable-dropdown-container'
        optionFilterProp='children'
        onChange={props.onChange}
        onSearch={props.onSearch}
        filterOption={filterOption}
        suffixIcon={props.loading ? <Spin /> : <ChevronDownIcon />}
        value={props.value}
        options={props.options}
        disabled={props.disabled}
      />
    );
  }
  return (
    <Select
      showSearch
      placeholder={props.placeholder}
      className='searchable-dropdown-container'
      optionFilterProp='children'
      onChange={props.onChange}
      onSearch={props.onSearch}
      filterOption={filterOption}
      suffixIcon={props.loading ? <Spin /> : <ChevronDownIcon />}
      value={props.value}
      options={props.options}
      disabled={props.disabled}
    />
  );
};
